import { Check, Users, Zap, Database, Popcorn } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import RazorpayButton from '@/components/RazorpayButton';

const HeroSection = () => {
  const currentPrice = '₹149/month!*';
  
  const features = [{
    icon: <Database className="w-5 h-5 text-primary" />,
    text: "Access 30 lakhs premium + active candidate pool"
  }, {
    icon: <Users className="w-5 h-5 text-primary" />,
    text: "Unlock 25 profiles per month (Non-tech hiring is limitless!)"
  }, {
    icon: <Zap className="w-5 h-5 text-primary" />,
    text: "5x higher applications vs free"
  }];

  return (
    <section className="py-12 lg:py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-foreground leading-tight">
                Unlock the power of Cutshort. 
                <span className="text-primary"> At a price less than Netflix </span>
                <Popcorn className="inline w-8 h-8 lg:w-10 lg:h-10 text-primary ml-2" />
              </h1>
              <div className="flex items-center gap-3">
                <Badge className="bg-accent text-accent-foreground font-bold">
                  NEW
                </Badge>
                <p className="text-xl font-semibold bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 bg-clip-text text-transparent">
                  🚀 Meet our new <span className="font-bold">Starter</span> plan
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-secondary rounded-full flex items-center justify-center">
                    {feature.icon}
                  </div>
                  <p className="text-lg text-foreground font-medium">{feature.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
            <Card className="p-8 bg-background border-2 border-border shadow-xl max-w-md w-full">
              <div className="bg-yellow-400 text-gray-900 text-center py-3 px-4 rounded-lg mb-6">
                <div className="text-xl font-bold">Just {currentPrice}</div>
              </div>

              <div className="text-center mb-6">
                <div className="flex justify-center mb-4">
                  <div className="w-full max-w-[240px] aspect-square">
                    <img 
                      src="/qr-code.png" 
                      alt="QR Code for payment" 
                      className="w-full h-full object-contain rounded-lg"
                      loading="eager"
                      width="240"
                      height="240"
                      onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/placeholder.svg'; }}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-4 min-h-[60px]" id="starter-payment">
                <p className="text-sm text-gray-700 mb-4 text-center">Click the button below to subscribe</p>
                <RazorpayButton 
                  buttonType="subscription"
                  subscriptionButtonId="pl_Qtiuzz3Pmg21GU"
                  buttonTheme="brand-color"
                />
                <p className="text-xs text-center text-gray-600 mt-2">Regular price is ₹2470/month. </p>
              </div>

            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;


